import { toDateTimeString } from "../../utilities/dateUtilities"
import stringHelpers from "../../utilities/stringHelpers"

export const DisallowedVrmDisplay = ({ allowedVrm }) => {
    return (
        <div className="card-body bg-light border-top details-container">
            <h6 className="mb-3 fs-1">Vehicle Details</h6>
            <div className="row">
                <div className="col-md-3 col-12  ">
                    <p className="font-weight-semi-bold  mb-3 mt-1">VRM</p>
                </div>
                <div className="col-md-6 col-12 "><p className="small-number-plate mb-0">{ allowedVrm.vrm }</p></div>
            </div>
            <div className="row mt-1">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Vehicle Make</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.vehicleMake }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3 ">Vehicle Model</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.vehicleModel }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3 ">Colour</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.vehicleColour }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Driver Details</h6>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Name</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.driverName }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Mobile Number</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.driverMobileNumber }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Email Address</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.driverEmailAddress }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Client/Site Details</h6>
            {
                !stringHelpers.isNullOrEmpty(allowedVrm.clientName)
                    ? <div className="row">
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold  mb-3">Client</p>
                        </div>
                        <div className="col-md-6 col-12 ">{ allowedVrm.clientName }</div>
                    </div>
                    : <div className="row">
                        <div className="col-md-3 col-12 ">
                            <p className="font-weight-semi-bold  mb-3">Site</p>
                        </div>
                        <div className="col-md-6 col-12 ">{ allowedVrm.siteName && allowedVrm.siteName !== null && <>{ allowedVrm.siteName }</> }{ !allowedVrm.siteName && <>All</> }</div>
                    </div>
            }
            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Date Details</h6>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Start Date</p>
                </div>
                <div className="col-md-6 col-12 ">{ toDateTimeString(allowedVrm.startDate) }</div>
            </div>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">End Date</p>
                </div>
                <div className="col-md-6 col-12 ">{ toDateTimeString(allowedVrm.endDate) }</div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className="col-md-3 col-12 ">
                    <p className="font-weight-semi-bold  mb-3">Notes</p>
                </div>
                <div className="col-md-6 col-12 ">{ allowedVrm.notes }</div>
            </div>
        </div>
    )
}